import type { ComponentProps } from "react";
import { PresenceStack } from "@components/avatar/PresenceStack";
import { TaskChipButton } from "@components/tasks/board/TaskChipButton";
import type { ClientsWorkOverviewWorkRow } from "../clientsWorkOverviewViewConfig";
import { WorkDateControl } from "../editing/WorkDateControl";
import { WorkTeamPopover } from "../editing/WorkRolePicker";
import { useWorkEditability } from "../editing/workItemEditing";
import { WorkCardDeliveryDate } from "./WorkCardTag";

/** The card's Work end tag; where the user can edit it, a chip that opens a calendar to update it. */
export const WorkCardDeliveryDateControl = ({
    row,
}: Readonly<{ row: ClientsWorkOverviewWorkRow }>) => {
    const { isItemEditable } = useWorkEditability();
    const tag = <WorkCardDeliveryDate row={row} />;
    if (!isItemEditable(row)) {
        return tag;
    }
    return (
        <WorkDateControl
            row={row}
            field="workDeliveryDate"
            trigger={
                <TaskChipButton aria-label="Work end">{tag}</TaskChipButton>
            }
        />
    );
};

/**
 * Who is on the card; where the user can reassign a role, a chip that opens
 * the engagement team. Otherwise a click opens the card's details.
 */
export const WorkCardPresence = ({
    row,
    members,
}: Readonly<{
    row: ClientsWorkOverviewWorkRow;
    members: ComponentProps<typeof PresenceStack>["members"];
}>) => {
    const { isTeamEditable } = useWorkEditability();
    const stack = <PresenceStack members={members} />;
    if (!isTeamEditable(row)) {
        return stack;
    }
    return (
        <WorkTeamPopover
            row={row}
            trigger={
                <TaskChipButton look="bare" aria-label="Engagement team">
                    {stack}
                </TaskChipButton>
            }
        />
    );
};
